export default "__VITE_PUBLIC_ASSET__0e49f3ae__"